import React, { useEffect, useState } from "react";
import primaryarrow from "../../images/primary-arrow.svg";
import stars from "../../images/stars.svg";
import { httpApi } from "api/http.api";
import { Spin } from "antd";
import { getAdvancedProfileSummery } from "api/candidate.api";
import { set } from "lodash";
import TooltipWrapper from "components/CandidateProfile/TooltipWrapper";
import { useAppSelector } from "hooks/reduxHooks";
import RelatedQuestions from "components/TalentPools/RelatedQuestions";

interface AdvanceCandidateSummaryProps {
    id?: number;
    isBioEdited?: boolean;
    editorName?: string;
    bio?: any | null;
    setAdvanceSummeryOpened?: React.Dispatch<React.SetStateAction<boolean>>;
    setAiBioData?: any;
    setRefresh?: React.Dispatch<React.SetStateAction<boolean>>;
    isListed?: boolean;
    autoLoadAdvancedSummary?: boolean;
}

const AdvanceCandidateSummary: React.FC<AdvanceCandidateSummaryProps> = ({ id, isBioEdited, editorName, bio, setAiBioData, setRefresh, isListed, autoLoadAdvancedSummary = true }) => {
    const [AIBioData, setAIBioData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<any>(null);

    const advancedProfileSummary = async () => {
        if (id) {
            setLoading(true);
            try {
                const res = await getAdvancedProfileSummery(id);
                setAIBioData(res.ai_search ?? res);
                if (setAiBioData) setAiBioData(res.ai_search ?? res);
                setError(null);
            } catch (error) {
                setAIBioData(null);
                if (setAiBioData) setAiBioData(null);
                setError(true);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (typeof id !== 'number') return;

        if (autoLoadAdvancedSummary) {
            advancedProfileSummary();
        }
    }, [id]);

    return (
        <div className="w-full p-5">
            <Spin spinning={loading} size="small">
                <RelatedQuestions
                    isListed={isListed}
                    isBioEdited={isBioEdited}
                    editorName={editorName || ""}
                    candidateId={id || 0}
                    bio={bio || ""}
                    error={error}
                    AIBioData={AIBioData}
                    loading={loading}
                    setRefresh={setRefresh}
                    bgColor="bg-bg-primary"
                />
            </Spin>
        </div>
    );
};

export default AdvanceCandidateSummary;